<div class="container">
  <button type="button" class="text-uppercase close" mat-button [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <div fxLayout="row">
    <mat-icon class="locked" *ngIf="data.displayTitleIcon">lock</mat-icon>
    <h1 mat-dialog-title>{{ data.reason }}</h1>
  </div>
  <mat-dialog-content>{{ data.callToAction }} </mat-dialog-content>
  <mat-dialog-actions>
    <a mat-flat-button class="primary" [href]="externalUrls.LineupUpgrade"> Contact Us To Upgrade </a>
    <a mat-stroked-button class="secondary" [href]="externalUrls.LineupPricing"> View Upgrade Options </a>
  </mat-dialog-actions>
</div>
